<section class="about-me t2 s3 shape-am position-relative" id="about">
  <div class="section-icons">
    <div class="shape-one"><img src="assets/images/testimonial/01.png" alt="images"></div>
    <div class="shape-two"><img src="assets/images/testimonial/02.png" alt="images"></div>
    <div class="shape-three"><img src="assets/images/testimonial/03.png" alt="images"></div>
    <div class="shape-four"><img src="assets/images/testimonial/04.png" alt="images"></div>
    <div class="shape-five"><img src="assets/images/testimonial/05.png" alt="images"></div>
    <div class="shape-six"><img src="assets/images/testimonial/06.png" alt="images"></div>
  </div>

  <div class="container">
    <div class="row position-relative">
      <div class="col-lg-7 animate-element wow delay5 fadeInDown">
        <div class="flat-title t2">
          <h4 class="sub-title mg-b22">About Me</h4>
          <h2 class="title-section color-d11 mg-b41">Hi, I am here to help you with your next
            project!</h2>
          <div class="description">
            <p class="color-d13 lt-sp01 text-left">
              I am an enthusiastic, responsible programmer and willing to learn more every day. 
              I have the desire to belong to a team to contribute all my knowledge. 
              I love taking advantage of every moment and space available to continue increasing my learning.
              I seek to improve my way of working as a team and solve problems with the correct use of the software.
            </p>
            <p class="color-d13 lt-sp01 text-left">
            </p>
          </div>
        </div>
      </div>
      <div class="fact">
        <app-tree></app-tree>
      </div>
      <div class="featured-post animate-element wow delay5 fadeInUp" data-wow-delay="0.5s">
        <img src="assets/images/section/51.png" alt="images">
      </div>
    </div>
  </div>
</section>
